<script lang="ts">
  import _, {update} from 'lodash';
  import Alwan from 'alwan';
  import 'alwan/dist/css/alwan.min.css';
  import {onMount} from 'svelte';
  import {each} from 'svelte/internal';
  import {httpClient} from '../../utils/http-client';
  import {SiteFonts} from '../../types/metadata';
  import {getImage, loadUserImageUrl} from '../../utils/common';
  import {AssetService} from '../../services';
  import {GoogleStorage} from '../../services/google/google.service';
  import {ASSET_CATEGORY} from '../../services/asset';
  import {fade} from 'svelte/transition';
  import Swal from 'sweetalert2';
  let loading = false;
  let brandkit: any = null;
  let isUploading = false;
  onMount(() => {
    loading = true;
    httpClient.get('/users/brandkit').then(res => {
      console.log('brandkit response', res);
      brandkit = res.data && res.data != '' ? res.data : {};
      loading = false;
    });
  });

  function updateBrandkit() {
    console.log('Updating brandkit', brandkit);
    httpClient.put('/users/brandkit/update', {brandKit: brandkit}).then(res => {
      console.log('Brandkit updated', res);
    });
  }
  function validateThatFileIsImage(file: File) {
    const validTypes = ['image/jpeg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      alert('Invalid file type. Please upload an image file.');
      return false;
    }
    return true;
  }

  async function getImageWidth(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = event => {
        const img = new Image();
        img.onload = () => {
          console.log('Image loaded successfully');
          resolve(img.naturalWidth);
        };
        img.onerror = error => {
          console.error('Error loading image', error);
          reject(new Error('Error loading image'));
        };
        if (event?.target?.result) img.src = event?.target?.result as string;
      };

      reader.onerror = error => {
        console.error('Error reading file', error);
        reject(new Error('Error reading file'));
      };

      reader.readAsDataURL(file);
    });
  }

  async function fileChanged(e: any) {
    const assetService = new AssetService();
    const file = e.target.files[0];
    validateThatFileIsImage(file);
    console.log('file', file);
    const imageWidth = await getImageWidth(file);
    if (imageWidth > 1024) {
      Swal.fire({
        position: 'bottom-end',
        icon: 'error',
        title: 'Failed to Upload Logo',
        text: `Image width is too large. Maximum width is 1024px`,
        showConfirmButton: false,
        timer: 10000,
        toast: true
      });
      return;
    }
    isUploading = true;

    const filename = file?.name;
    const generatedFilename = 'images/' + filename;
    const url = await assetService.generateNames([generatedFilename]);
    const data = url.data;

    await GoogleStorage.uploadFileFromSignedUrl(data[0], file, {
      onProgress: progress => {
        console.log('Progress', progress);
      },
      onComplete: () => {}
    });

    await assetService
      .saveUploadedAsset([generatedFilename], ASSET_CATEGORY.IMAGE)
      .then(response => {
        brandkit.logo = response.data.file.publicUrl;
        updateBrandkit();
        isUploading = false;
      })
      .catch(error => {
        console.error(error);
        isUploading = false;
        Swal.fire({
          position: 'bottom-end',
          icon: 'error',
          title: 'Failed to Upload Logo',
          showConfirmButton: false,
          timer: 10000,
          toast: true
        });
      });
  }

  function openFileUploadDialog() {
    const fi = document.createElement('input');
    fi.addEventListener('change', fileChanged);
    fi.type = 'file';
    fi.accept = 'image/*';
    fi.click();
  }

  function openFileUploadDialogForFont() {
    const fi = document.createElement('input');
    fi.addEventListener('change', fontFileChanged);
    fi.type = 'file';
    fi.accept = '.ttf, .otf, .woff, .woff2';
    fi.click();
  }

  async function fontFileChanged(e: any) {
    const assetService = new AssetService();
    const file = e.target.files[0];
    const filename = file?.name;
    const generatedFilename = 'fonts/' + filename;
    const url = await assetService.generateNames([generatedFilename]);
    const data = url.data;

    await GoogleStorage.uploadFileFromSignedUrl(data[0], file, {
      onProgress: progress => {
        console.log('Progress', progress);
      },
      onComplete: () => {}
    });

    await assetService
      .saveUploadedAsset([generatedFilename], ASSET_CATEGORY.FONT)
      .then(response => {
        brandkit.logo = response.data.file.publicUrl;
        updateBrandkit();
        isUploading = false;
      })
      .catch(error => {
        console.error(error);
        isUploading = false;
        Swal.fire({
          position: 'bottom-end',
          icon: 'error',
          title: 'Failed to Upload Logo',
          showConfirmButton: false,
          timer: 10000,
          toast: true
        });
      });
  }

  function changeColor(i: number) {}

  let pickers: {i: number; picker: Alwan}[] = [];
  function openColorPicker(i: number) {
    const picker = pickers.find(p => p.i === i);
    if (picker) picker.picker.open();
    else {
      console.warn('Color picker not found');
    }
  }
  function triggerOpen(index: number) {
    console.log('Triggering open', index);
    setTimeout(() => {
      pickers[index].picker.open();
    }, 100);
  }
  function applyFont(font: string, el: HTMLElement, target: string) {
    console.log('applying font', font, el);
    brandkit[target] = font;
    updateBrandkit();
    el.classList.add('hidden');
  }
  function colorPicker(node: any, {i}: any) {
    console.log('Creating color picker element', node, i);
    const defaultColor = brandkit['color' + i] || '#000000';
    const picker = new Alwan(node, {
      swatches: ['#000000', '#ffffff'],
      format: 'hex',
      preview: false,
      default: defaultColor,
      color: defaultColor
    });
    pickers.push({
      i,
      picker
    });
    picker.on('change', () => {
      console.log('Color changed');
      updateBrandkit();
    });
    picker.on('color', ev => {
      console.log('Color updated');
      brandkit['color' + i] = ev.hex;
    });
  }

  function toggleDropdown(e: any) {
    const dropdownItem = e.target.querySelector('.dropdown') as HTMLElement;
    const isHidden = dropdownItem.classList.contains('hidden');
    if (!isHidden) {
      e.target.classList.remove('bg-primary', 'text-white');
      dropdownItem.classList.add('hidden');
    } else {
      e.target.classList.add('bg-primary', 'text-white');
      dropdownItem.classList.remove('hidden');
    }
  }

  function updateBrandkitSocial(social: string, value: string, index: number) {
    console.log('Updating social', social, value);
    if (!brandkit.socials) brandkit.socials = {};
    brandkit.socials[social] = value;
    updateBrandkit();
    clearInput(index);
  }
  let fontDropdownElems = [];

  const fontLabelMap: any = {
    font1: 'Heading',
    font2: 'Subheading',
    font3: 'Body'
  };

  let activeInputs: any[] = [];
  let inputElements: any[] = [];
  function changeInput(i: number, social: string) {
    if (inputElements[i]?.value == brandkit.socials?.[social]) {
      if (activeInputs.includes(i)) activeInputs = activeInputs.filter(index => index !== i);
    } else {
      if (!activeInputs.includes(i)) activeInputs = [...activeInputs, i];
      console.log(activeInputs);
    }
  }
  function clearInput(i: number) {
    activeInputs = activeInputs.filter(index => index !== i);
  }

  $: logoUrl = brandkit?.logo?.includes('https')
    ? brandkit.logo
    : brandkit?.logo
      ? loadUserImageUrl('brandKit/' + brandkit.logo)
      : '';
</script>

<div class="block">
  {#if loading || !brandkit}
    <div class="text-lg font-bold text-gray-500">
      <i class="fa fa-spinner animate-spin" /> Loading Information...
    </div>
  {:else}
    <div class="col-span-2">
      <h2 class="mb-2 bg-gradient-to-r text-[24px] font-bold text-gray-900">Set up your Brand Kit</h2>
      <div class="inputgroup" id="logo-block">
        <h3>Logo</h3>
        <div
          class="flex h-[130px] w-[130px] border-spacing-2 cursor-pointer items-center justify-center overflow-hidden rounded-lg border border-dashed border-gray-300 text-center align-middle"
          on:click={openFileUploadDialog}
          on:keypress={openFileUploadDialog}
        >
          {#if brandkit?.logo && !isUploading}
            <img src={logoUrl} alt="logo" class="h-full w-full" />
          {:else if isUploading}
            <div class="my-2 flex flex-col items-center justify-center gap-4">
              <i class="fa-solid fa-spinner animate-spin text-lg"></i>
            </div>
          {:else}
            <div class="block">
              <i class="fa fa-plus text-lg text-gray-300" />
            </div>
          {/if}
        </div>
      </div>
      <!-- End of Logo-block-->

      <div class="inputgroup" id="colors-block">
        <h3>Colors</h3>
        <div class="flex space-x-3">
          {#each Array(3) as _, i}
            {#if brandkit['color' + (i + 1)]}
              <div
                class="flex h-16 w-16 cursor-pointer items-center justify-center rounded-lg border border-dashed border-gray-300 text-center align-middle"
                style="background-color: {brandkit['color' + (i + 1)]}"
                on:click={() => openColorPicker(i)}
                on:keypress={() => openColorPicker(i)}
              >
                <div use:colorPicker={{i: i + 1}}></div>
              </div>
            {:else}
              <div
                class="flex h-16 w-16 cursor-pointer items-center justify-center rounded-lg border border-dashed border-gray-300 text-center align-middle"
                on:click={() => {
                  brandkit['color' + (i + 1)] = '#000000';
                  triggerOpen(i);
                }}
                on:keypress={() => {
                  brandkit['color' + (i + 1)] = '#000000';
                  triggerOpen(i);
                }}
              >
                <div class="block">
                  <i class="fa fa-plus text-xl text-gray-300" />
                </div>
              </div>
            {/if}
          {/each}
        </div>
      </div>
      <!-- End of Colors-block-->

      <div class="inputgroup" id="typography-block">
        <h3>Typography</h3>
        <div class="flex space-x-3 text-gray-600">
          {#each ['font1', 'font2', 'font3'] as _, i}
            <div class="typography-item" id={_} on:click={toggleDropdown}>
              <span style="font-family: '{brandkit[_]}'" class="btn pointer-events-none">Add a {fontLabelMap[_]}</span>
              <div class="dropdown z-50 hidden text-gray-600" bind:this={fontDropdownElems[i]}>
                {#each SiteFonts as font}
                  <div
                    class="item {brandkit[_] == font ? 'active' : ''}"
                    style="font-family:'{font}'"
                    on:click={() => applyFont(font, fontDropdownElems[i], _)}
                  >
                    {font}
                  </div>
                {/each}
              </div>
            </div>
          {/each}
        </div>
      </div>
      <!-- End of typography block-->

      <div class="inputgroup">
        <h3>Socials</h3>
        {#each ['TikTok', 'Facebook', 'Instagram', 'YouTube', 'Email', 'Website'] as _, i}
          <div class="subgroup relative">
            <h4>{_}</h4>
            <input
              class="text"
              placeholder="Type or place link here"
              type="text"
              value={brandkit.socials?.[_] || ''}
              on:change={e => updateBrandkitSocial(_, e.target.value, i)}
              bind:this={inputElements[i]}
              on:input={() => changeInput(i, _)}
            />
            {#if activeInputs.includes(i)}
              <div
                in:fade={{duration: 200}}
                out:fade={{duration: 100}}
                class="absolute right-2 top-[2.3rem] rounded-lg bg-gray-100 px-3.5 py-1.5 text-xs font-semibold text-gray-500 opacity-80"
              >
                Hit enter to save
              </div>
            {/if}
          </div>
        {/each}
      </div>
    </div>
  {/if}
</div>

<style lang="postcss">
  h3 {
    @apply block pb-4 text-gray-800;
    font-family: 'Roboto';
    font-size: 18px;
    font-weight: 800;
  }
  h4 {
    @apply text-gray-800;
    margin-bottom: 6px;
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
  .typography-item.active {
    @apply bg-primary-600 font-extrabold text-white;
  }
  .typography-item {
    @apply relative w-44 cursor-pointer text-ellipsis rounded-lg border-2 border-dashed border-gray-300 px-4 py-2 text-center;

    .dropdown {
      @apply absolute left-0 mt-4 max-h-56 min-h-4 w-full cursor-default overflow-y-scroll rounded-lg bg-white p-4 shadow-lg;
      .item {
        @apply cursor-pointer border-y border-gray-100 py-2 hover:bg-gray-50;
        &.active {
          @apply pointer-events-none bg-gray-100;
        }
      }
    }
  }
  .inputgroup {
    @apply mb-12 block;
  }
  input.text {
    @apply w-full rounded-lg border border-gray-300 p-2;
  }

  .subgroup {
    @apply mb-6 block;
  }
</style>
